var map = {
	"./menu/business-hour-black.svg": "a6bb",
	"./menu/email-black.svg": "0e52",
	"./menu/events-black.svg": "08d0",
	"./menu/general-black.svg": "8b01",
	"./menu/iot-black.svg": "7f31",
	"./menu/operator-app-black.svg": "9891",
	"./menu/payments-black.svg": "23dd2",
	"./menu/point-black.svg": "815e",
	"./menu/profile-black.svg": "616f",
	"./menu/quiz-black.svg": "f868",
	"./menu/rent-black.svg": "afcc",
	"./menu/rider-app-black.svg": "1195",
	"./menu/security-black.svg": "2f31",
	"./menu/trip-black.svg": "8576",
	"./menu/vehicle-black.svg": "e678"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "85a5";